const module = { name: 'person/overview/wall', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



const Selectors = {
    ITEM: '.content-item-container',
    WALL: '.content-item-list.wall',
}
function init() {
    const $container = $(Selectors.WALL);
    $container.imagesLoaded(() => {
        $container.isotope({
            itemSelector: Selectors.ITEM
        });
        $(window).on('resize', $.debounce(250, () => $container.isotope()));
    });
}
module.exports = {
    init
};
export default module.exports;